import { GameProgress } from '../types/GameProgress';
import { NORMAL_MONSTER_IDS } from '../constants/monsters';
import { AILevel } from '../ai/types';

export interface ChallengeBattleData {
  monsterId: string;
  enemyMonsterId: string;
  aiLevel: AILevel;
  isHiddenChallenge: true;
  challengeTargetId: string;
}

/**
 * ボス初撃破時にモココヒントを表示すべきか判定する。
 * progressはupdateBossDefeatedWith呼び出し前の状態を渡すこと。
 */
export function shouldShowBossFirstClearHint(progress: GameProgress): boolean {
  const defeated = progress.bossDefeatedWith ?? [];
  const unlocked = progress.unlockedHiddenMonsters ?? [];
  return defeated.length === 0 && !unlocked.includes('mococo');
}

/**
 * 大会初優勝時にアリスヒントを表示すべきか判定する。
 * progressはrecordAnyTournamentWin呼び出し前の状態を渡すこと。
 */
export function shouldShowTournamentFirstWinHint(progress: GameProgress): boolean {
  const unlocked = progress.unlockedHiddenMonsters ?? [];
  return !progress.anyTournamentWon && !unlocked.includes('alice');
}

/**
 * アリス挑戦戦を発動すべきか判定する。
 * 条件: キャンペーン全クリア AND 熟練以上大会優勝 AND alice未解放
 */
export function shouldTriggerAliceChallenge(progress: GameProgress): boolean {
  const unlocked = progress.unlockedHiddenMonsters ?? [];
  return (
    progress.clearedStages >= 9 &&
    progress.tournamentWonAtShukuren === true &&
    !unlocked.includes('alice')
  );
}

/**
 * モココ挑戦戦を発動すべきか判定する。
 * 条件: 全8通常魂格でボス撃破 AND mococo未解放
 */
export function shouldTriggerMococoChallenge(progress: GameProgress): boolean {
  const defeated = new Set(progress.bossDefeatedWith ?? []);
  const unlocked = progress.unlockedHiddenMonsters ?? [];
  return (
    NORMAL_MONSTER_IDS.every((id) => defeated.has(id)) &&
    !unlocked.includes('mococo')
  );
}

/**
 * アリス挑戦戦のバトルデータを生成する。
 * 敵はアリス最終値・AI LV6。
 */
export function createAliceChallengeBattleData(playerMonsterId: string): ChallengeBattleData {
  return {
    monsterId: playerMonsterId,
    enemyMonsterId: 'alice',
    aiLevel: AILevel.LV6,
    isHiddenChallenge: true,
    challengeTargetId: 'alice',
  };
}

/**
 * モココ挑戦戦のバトルデータを生成する。
 * 敵はモココ最終値・AI LV6。
 */
export function createMococoChallengeBattleData(playerMonsterId: string): ChallengeBattleData {
  return {
    monsterId: playerMonsterId,
    enemyMonsterId: 'mococo',
    aiLevel: AILevel.LV6,
    isHiddenChallenge: true,
    challengeTargetId: 'mococo',
  };
}
